import React, { useMemo } from 'react';
import range from 'lodash/range';
import useExpanderHandler from "../Hooks/useExpanderHandler";
import { ExpanderContainer } from "../components";
var createExpanded = function createExpanded(expander, data, unclickableColumns, customTdFunctions) {
  var expandedProps = {};
  var viewIndexes = useMemo(function () {
    return range(0, data.length);
  }, [data.length]);
  var _useExpanderHandler = useExpanderHandler(viewIndexes),
    handleAnimationExpand = _useExpanderHandler.handleAnimationExpand,
    handleExpand = _useExpanderHandler.handleExpand,
    expandedLines = _useExpanderHandler.expandedLines,
    expandedAnimationLines = _useExpanderHandler.expandedAnimationLines;
  expandedProps.expanded = expandedLines;
  expandedProps.SubComponent = function (row) {
    var opened = expandedAnimationLines[row.viewIndex] === true;
    var expanderComponent = expander(row);
    return expanderComponent !== null && /*#__PURE__*/React.createElement(ExpanderContainer, {
      opened: opened,
      onExit: function onExit() {
        return handleAnimationExpand(row.viewIndex);
      }
    }, expanderComponent);
  };
  expandedProps.getTdProps = function (state, rowInfo, column) {
    return {
      onClick: function onClick(e, handleOriginal) {
        if (customTdFunctions && customTdFunctions.some(function (func) {
          return func(state, rowInfo, column);
        })) {
          return;
        }
        if (window.getSelection().toString().length > 0) {
          return;
        }
        var isClickableColumn = !unclickableColumns || !unclickableColumns.includes(column.id);
        var hasExpander = expander(rowInfo) !== null;
        if (isClickableColumn && hasExpander) {
          handleExpand(rowInfo.viewIndex);
          return;
        }
        if (handleOriginal) {
          handleOriginal();
        }
      }
    };
  };
  return expandedProps;
};
export default createExpanded;